import { CIcon } from '~/icons/types'

export const ciStar: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.5 9.9c0-.5 0-.7-7.1-1.4-2.6-6-3.1-6-3.4-6-.3 0-.8 0-3.4 6-7.1.7-7.1.8-7.1 1.4 0 .3 0 .5 4.9 4.8-1.4 6.3-1.2 6.5-1 6.7.3.3.4.4 6.5-2.9 4.3 2.5 5.7 3 6.2 3 .2 0 .3-.1.4-.1.2-.2.5-.5-1-6.7 5-4.4 5-4.6 5-4.8Zm-5.8 4.2c-.1.1-.2.3-.2.5.5 2.2 1.1 4.7 1.2 5.8-1-.4-3.4-1.7-5.5-2.9-.1 0-.2-.1-.2-.1-.1 0-.2 0-.2.1-2.1 1.1-4.3 2.3-5.4 2.8.2-1.1.6-3.5 1.1-5.7 0-.2 0-.4-.2-.5-1.7-1.5-3.5-3.1-4.4-3.9 1.2-.2 3.8-.5 6.1-.8.2 0 .3-.1.4-.3.9-2.1 2.1-4.5 2.6-5.4.5.9 1.7 3.2 2.6 5.4.1.2.2.3.4.3 2.3.2 4.8.5 6 .7-.8.9-2.6 2.5-4.3 4Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'star',
  type: 'thin'
}
